import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { changeBlogTag } from '../../redux/CmnBlog';
import { Col, Container, Row, Card, CardBody, Button } from 'reactstrap';
import { GetBlogById, GetBlogList, GetBlogAboutUs } from '../../services/CmnBlogService';
import { toBlogDateFormat, toDate } from '../../helpers/formatter';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
// import {Helmet} from "react-helmet";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

class BlogDtl extends Component {

  constructor(props) {
    super(props);

    this.state = {
      blogDetail: {},
      recentBlogList: [],
      currentId: "",
      loading: true,
      listLoading: true,
      blogAboutUs: "",
    }

    this.onTagChange = this.onTagChange.bind(this);
  }

  onTagChange(blogTagId) {
    this.props.changeBlogTag(blogTagId);
  }

  componentDidMount() {
    const { dtlId } = this.props.match.params;
    GetBlogById(dtlId).then(
      (resp) => {
        this.setState({
          blogDetail: resp.data.data[0],
          currentId: resp.data.data[0].BlogId,
          loading: false
        });

        document.title = "FintruX Blog - " + resp.data.data[0].BlogTitle;
      },
      (error) => {
        console.log(error);
      }
    )

    GetBlogList(5, 0, 0).then(
      (resp) => {
        this.setState({
          recentBlogList: resp.data.data,
          listLoading: false
        });
      },
      (error) => {
        console.log(error);
      }
    )

    GetBlogAboutUs().then(
      (resp) => {
        this.setState({
          blogAboutUs: resp.data.data[0],
        });
      },
      (error) => {
        console.log(error);
      }
    )
  }

  componentDidUpdate(prevprops, prevstates) {
    const { dtlId } = this.props.match.params;

    if (prevstates.currentId !== dtlId) {
      GetBlogById(dtlId).then(
        (resp) => {
          this.setState({
            blogDetail: resp.data.data[0],
            currentId: resp.data.data[0].BlogId,
            loading: false
          });
        },
        (error) => {
          console.log(error);
        }
      )

      GetBlogList(5, 0, 0).then(
        (resp) => {
          this.setState({
            recentBlogList: resp.data.data,
            listLoading: false
          });
        },
        (error) => {
          console.log(error);
        }
      )
    }
  }

  render() {
    const BlogDetail = this.state.blogDetail;
    const recentBlogList = this.state.recentBlogList;
    const staticFileUrl = (document.Rintagi || {}).staticFileUrl;
    const blogAboutUs = this.state.blogAboutUs;

    return (
      <Container className="mt-60">
        {/* <Row>
          <Col md={12}>
            <MetaTags>
              <meta property="og:title" content={BlogDetail.BlogTitle} />
              <meta property="og:description" content={BlogDetail.BlogDesc} />
              <meta property="og:image" content="http://blog.fintrux.com/metaImg.jpg" />
              <meta property="og:url" content="http://blog.fintrux.com" />
              <meta name="twitter:card" content="summary_large_image" />
              <meta name="twitter:title" content={BlogDetail.BlogTitle} />
              <meta name="twitter:description" content={BlogDetail.BlogDesc} />
              <meta name="twitter:image" content="http://blog.fintrux.com/metaImg.jpg" />
              <meta name="twitter:site" content="http://blog.fintrux.com" />
            </MetaTags>

          </Col>
        </Row> */}
        <Row>
          <Col md={12} lg={7} xl={8}>
            {this.state.loading === true && <div>
              <div><SkeletonTheme color="#E8F0F5"><div className="cntSkeletonSec"><Skeleton /></div></SkeletonTheme></div>
              <div><SkeletonTheme color="#E8F0F5"><div className="imgSkeletonSec"><Skeleton /></div></SkeletonTheme></div>
              <div><SkeletonTheme color="#E8F0F5"><div className="cntSkeletonSec"><Skeleton count={4} /></div></SkeletonTheme></div>
            </div>
            }
            {this.state.loading === false &&
              <div className="blogDetailPlaceholder">
                {/* <img src={BlogDetail.PicMed ? "data:application/base64;base64," + BlogDetail.PicMed : ""} alt="product-img" /> */}
                <h1 className='detailTitle'>
                  {BlogDetail.BlogTitle}
                </h1>
                <hr />
                <h6 className="bLogDate"><b>{(BlogDetail || {}).BlogHeader}</b></h6>
                <h6 className="bLogDate">• {toBlogDateFormat(BlogDetail.BlogDate)} • By FintruX Team • 5 mins read</h6>
                <hr />
                <div dangerouslySetInnerHTML={{ __html: (BlogDetail.BlogDetail ? BlogDetail.BlogDetail.replace(/\"dev\//g, "\"" + staticFileUrl + "/dev/") : "") }}></div>
                <hr />
                <div dangerouslySetInnerHTML={{ __html: (blogAboutUs.BlogAboutUsDesc ? blogAboutUs.BlogAboutUsDesc.replace(/\"dev\//g, "\"" + staticFileUrl + "/dev/") : "") }}></div>
              </div>
            }
          </Col>
          <Col md={12} lg={1} xl={1}></Col>
          <Col md={12} lg={4} xl={3}>
            <div className="recentBlogTitle mb-40">
              <h3>RECENT BLOGS</h3>
              <br />
              {/* <hr /> */}
            </div>
            <div>
              {this.state.listLoading === true &&
                <Row className="mb-40">
                  <Col md={12} lg={12}>
                    <div><SkeletonTheme color="#E8F0F5"><div className="cntSkeletonSec"><Skeleton /></div></SkeletonTheme></div>
                    <div><SkeletonTheme color="#E8F0F5"><div className="imgSkeletonSec"><Skeleton /></div></SkeletonTheme></div>
                    <div><SkeletonTheme color="#E8F0F5"><div className="cntSkeletonSec"><Skeleton count={4} /></div></SkeletonTheme></div>
                  </Col>
                </Row>
              }

              {this.state.listLoading === false && recentBlogList.map((item, i) => {
                return <Row className="mb-40" key={i}>
                  <Col md={12} lg={12}>
                    <div className="detaiRecentBlg">
                      <div className="imageSec">
                        <img src={("data:application/base64;base64," + item.PicMed)} alt='catalog-item-img' />
                      </div>

                      <div className="contentSec">
                        <h5 className="pastBLogDate">{toBlogDateFormat(item.BlogDate)}</h5>
                        <h4>
                          <Link className="link" to={'/BlogDtl/' + item.BlogId + '/' + item.BlogTitle.split(' ').join('')} >
                            <span className="underlineThin">
                              {item.BlogTitle}
                            </span>
                          </Link>
                        </h4>
                        {/* <p>{toBlogDateFormat(item.BlogDate)} - 5 mins read</p> */}
                        {/* <p className="viewMoreBtn"><Link className="link" to={'/BlogDtl/' + item.BlogId} >Read More...</Link></p> */}
                        <h6 className='postBy'>By FintruX Team</h6>
                        {
                          item.BlogTagName ?
                            (<div className="blogTagContainer"><a className="blogTag" href={"BlogList/"} onClick={() => { this.onTagChange(item.BlogTagId) }}>{item.BlogTagName}</a></div>) : null
                        }
                      </div>
                    </div>
                  </Col>
                </Row>
              }
              )}
            </div>
          </Col>
        </Row>
      </Container>
    )
  }
}
const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    { changeBlogTag: changeBlogTag }
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(BlogDtl);


// WEBPACK FOOTER //
// ./src/pages/CmnBlog/BlogDtl.js